
export default function (Component) {
  Component.options.__source = "src/directives/empty/empty.vue"
}
